import { newApiFetchV2 } from "./utils";

export const getModels = () => newApiFetchV2("/_the_models", {});
